import React from 'react';
import type { Invoice } from '@hero/schema';
import type { InvoiceTableColumn } from '@hero/hooks-shared';
import { InvoiceTableCell } from './InvoiceCell';

export interface InvoiceRowProps {
  invoice: Invoice;
  displayForUser: 'customer' | 'carrier';
  columns: InvoiceTableColumn[];
  /** Whether to show days-left on the due column */
  showDaysLeft?: boolean;
  /** Called when the pay action button is clicked */
  onPayInvoice?: (invoice: Invoice) => void;
  /** Called when the upload proof action is triggered (carrier only) */
  onUploadProof?: (invoice: Invoice) => void;
  /**
   * Called when the per-row "Finance" chip is clicked (carrier
   * only). Manager wires it to navigate to the financing apply
   * form with the invoice pre-selected.
   */
  onFinanceInvoice?: (invoice: Invoice) => void;
}

/**
 * Renders the cells for a single invoice row.
 * Delegates each cell to InvoiceTableCell — same pattern as OrderRow.
 *
 * NOTE: Do NOT wrap in <TableRow> — SharedTable.Rows already provides the wrapper.
 */
export const InvoiceRow: React.FC<InvoiceRowProps> = ({
  invoice,
  displayForUser,
  columns,
  showDaysLeft = false,
  onPayInvoice,
  onUploadProof,
  onFinanceInvoice,
}) => {
  return (
    <>
      {columns.map(column => (
        <InvoiceTableCell
          key={column.key}
          column={column}
          invoice={invoice}
          displayForUser={displayForUser}
          showDaysLeft={showDaysLeft}
          onPayInvoice={onPayInvoice}
          onUploadProof={onUploadProof}
          onFinanceInvoice={onFinanceInvoice}
        />
      ))}
    </>
  );
};
